import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';
import { AppCard } from '../general';
import { AuwVendorBreakdownItem } from '../../models/reporting/reporting';

interface AuwVendorTableProps {
  title: string;
  vendors: AuwVendorBreakdownItem[];
  onVendorClick?: (vendorId: number) => void;
}

const AuwVendorTable = (props: AuwVendorTableProps): JSX.Element => {
  const { title, vendors, onVendorClick } = props;

  const completionRateBody = (rowData: AuwVendorBreakdownItem) => {
    if (rowData.completionRate == null || isNaN(rowData.completionRate)) return <span className="text-gray-400">N/A</span>;
    const severity = rowData.completionRate >= 95 ? 'success' : rowData.completionRate >= 80 ? 'warning' : 'danger';
    return <Tag severity={severity} value={`${rowData.completionRate}%`} className="text-xs" />;
  };

  const avgServiceRequestBody = (rowData: AuwVendorBreakdownItem) => {
    if (rowData.avgServiceRequestCount == null) return <span className="text-gray-400">--</span>;
    return <span>{rowData.avgServiceRequestCount.toLocaleString()}</span>;
  };

  const vendorBody = (rowData: AuwVendorBreakdownItem) => {
    if (onVendorClick) {
      return (
        <span
          className="text-blue-600 hover:underline cursor-pointer font-medium"
          onClick={() => onVendorClick(rowData.vendorId)}
        >
          {rowData.vendor}
        </span>
      );
    }
    return <span className="font-medium">{rowData.vendor}</span>;
  };

  return (
    <AppCard title={title}>
      <DataTable value={vendors} size="small" stripedRows emptyMessage="No data">
        <Column field="vendor" header="Vendor" body={vendorBody} />
        <Column field="count" header="Total" sortable />
        <Column field="successCount" header="Success" sortable />
        <Column field="failedCount" header="Failed" sortable />
        <Column field="inProgressCount" header="In Progress" sortable />
        <Column field="canceledCount" header="Canceled" sortable />
        <Column header="Completion Rate" body={completionRateBody} />
        <Column header="Avg Service Requests" body={avgServiceRequestBody} />
      </DataTable>
    </AppCard>
  );
};

export default AuwVendorTable;
